//const locale = window.navigator.language || 'en-GB';

import {hideLoader, showLoader} from './loaders';
import {showCommunicationError, showWarning} from './alerts';
import Cookies from 'js-cookie';
import moment from 'moment';

export const DATE_TIME_FORMAT_COOKIE = 'DATE_TIME_FORMAT';
let currentDateTimeFormat: string | undefined = Cookies.get(DATE_TIME_FORMAT_COOKIE);

export function setCurrentDateTimeFormat(format?: string) {
    currentDateTimeFormat = format;
    showWarning('Setting updated', 'You should refresh your browser to take effect');
}

export function formatDateTime(d?: Date | null): string {
    if (!d) {
        return '';
    }
    //return DateTime.fromJSDate(d).setLocale(locale).toLocaleString();
    if (currentDateTimeFormat) {
        return moment(d).format(currentDateTimeFormat);
    } else {
        return d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
    }

}

export function formatDate(d?: Date): string {
    if (!d) {
        return '';
    }
    //return DateTime.fromJSDate(d).setLocale(locale).toLocaleString();
    if (currentDateTimeFormat) {
        return moment(d).format(currentDateTimeFormat.split(' ')[0]);
    }

    return d.toLocaleDateString();
}

export function isTestEnv() {
    return document.location.host.includes('test') || document.location.host.includes('localhost');
}

export function loadScript(url: string, id: string): Promise<boolean> {
    if (document.getElementById(id) !== null) {
        return Promise.resolve(false);
    }

    return new Promise((resolve, reject) => {
        showLoader();
        const script: HTMLScriptElement = document.createElement('script');
        script.type = 'text/javascript';
        script.id = id;

        script.onload = function() {
            hideLoader();
            resolve(true);
        };

        script.onerror = function(e) {
            hideLoader();
            showCommunicationError(e);
            reject();
        };

        script.src = url;
        document.getElementsByTagName('head')[0].appendChild(script);

    });
}

export function generateUUID(): string {
    let d = new Date().getTime();

    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now();
    }

    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });

    return uuid;
}

export const toggleInArrayImmutable = (arr: Array<any>, item: any) => arr.includes(item) ? arr.filter(i => i !== item) : [...arr, item];

export function toggleInArray(S: Array<any>, x: any) {
    S[x] = 1 - (S[x] | 0);
}
